module.exports = __webpack_public_path__ + "img/lenovo-laptop.4198ba78.png";